/**
 * CUSTOM PRODUCT ACCORDION - Re:Voir
 * Transforme les H4 de la description produit en accordéon
 */

(function() {
  'use strict';

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAccordion);
  } else {
    initAccordion();
  }

  function initAccordion() {
    // Chercher la description du produit (Rise utilise généralement ces sélecteurs)
    const descriptionSelectors = [
      '.product__description',
      '.product-description',
      '[class*="description"]',
      '.rte'
    ];

    let descriptionDiv = null;
    
    for (const selector of descriptionSelectors) {
      const elements = document.querySelectorAll(selector);
      for (const el of elements) {
        // Vérifier si l'élément contient des H4
        if (el.querySelector('h4')) {
          descriptionDiv = el;
          break;
        }
      }
      if (descriptionDiv) break;
    }

    if (!descriptionDiv) {
      console.log('Custom Accordion: Description container not found');
      return;
    }

    createAccordion(descriptionDiv);
  }

  function createAccordion(descriptionDiv) {
    const descriptionHTML = descriptionDiv.innerHTML;
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = descriptionHTML;
    const elements = Array.from(tempDiv.children);
    
    let technicalDetails = [];
    let sections = [];
    let currentSection = null;
    
    // Parser les éléments de la description
    elements.forEach((el) => {
      if (el.tagName === 'H4') {
        // Sauvegarder la section précédente
        if (currentSection) {
          sections.push(currentSection);
        }
        // Créer une nouvelle section
        currentSection = {
          title: el.textContent.trim(),
          content: []
        };
      } else if (currentSection) {
        // Ajouter le contenu à la section courante
        currentSection.content.push(el.outerHTML);
      } else {
        // Contenu avant le premier H4 = détails techniques
        technicalDetails.push(el.outerHTML);
      }
    });
    
    // Ajouter la dernière section
    if (currentSection) {
      sections.push(currentSection);
    }
    
    // Si on a du contenu technique SANS aucun H4, ne rien créer
    if (sections.length === 0 && technicalDetails.length === 0) {
      console.log('Custom Tabs: No content found, skipping');
      return;
    }
    
    // Si on a du contenu technique, l'ajouter comme premier onglet "Informations"
    if (technicalDetails.length > 0) {
      sections.unshift({
        title: 'Détails',
        content: technicalDetails
      });
    }
    
    // Construire le nouveau HTML avec onglets horizontaux
    let newHTML = '<div class="custom-product-tabs">';
    
    // Barre d'onglets horizontale
    newHTML += '<div class="custom-tabs-nav">';
    
    sections.forEach((section, index) => {
      const tabId = `tab-${index}`;
      const isFirst = index === 0;
      newHTML += `
        <button 
          class="custom-tab-button ${isFirst ? 'active' : ''}" 
          data-tab="${tabId}"
        >
          ${section.title}
        </button>
      `;
    });
    
    newHTML += '</div>'; // Fin nav
    
    // ← AJOUT: Ligne de séparation
    newHTML += '<div class="custom-tabs-separator"></div>';
    
    // Contenus des onglets
    newHTML += '<div class="custom-tabs-content-wrapper">';
    
    sections.forEach((section, index) => {
      const tabId = `tab-${index}`;
      const isFirst = index === 0;
      newHTML += `
        <div 
          class="custom-tab-content ${isFirst ? 'active' : ''}" 
          id="${tabId}"
        >
          ${section.content.join('')}
        </div>
      `;
    });
    
    newHTML += '</div>'; // Fin wrapper
    newHTML += '</div>'; // Fin tabs
    
    // Remplacer le contenu de la description
    descriptionDiv.innerHTML = newHTML;
    
    // Ajouter les event listeners pour les clics sur onglets
    const tabButtons = descriptionDiv.querySelectorAll('.custom-tab-button');
    tabButtons.forEach((button) => {
      button.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab');
        
        // Désactiver tous les onglets et contenus
        descriptionDiv.querySelectorAll('.custom-tab-button').forEach(btn => {
          btn.classList.remove('active');
        });
        descriptionDiv.querySelectorAll('.custom-tab-content').forEach(content => {
          content.classList.remove('active');
        });
        
        // Activer l'onglet cliqué et son contenu
        this.classList.add('active');
        const targetContent = document.getElementById(tabId);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
    
    console.log('Custom Tabs: Created with', sections.length, 'tabs');
  }

  // Réinitialiser si Shopify recharge une section
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', initAccordion);
  }
})();